import React from 'react'

import FormMessage from './components/FormMessage.jsx';

import { MapPin, Phone, Mail, Clock, Instagram, Send } from 'lucide-react';

function SecondSection() {
  const handleAddressClick = () => {
    window.open('https://www.google.com/maps/dir/?api=1&destination=-6.134073932372211,106.73355385491381', '_blank');
  }

 const handleEmailClick = () => {
    window.open('https://mail.google.com/mail/?view=cm&fs=1&to=papakilobarbershop@gmail.com', '_blank');
  };

  const handleInstagramClick = () => {
    window.open('https://www.instagram.com/papakilo.hairstudio/', '_blank');
  };

  const handlePhoneClick = () => {
    const whatsappUrl = `https://wa.link/hecanu`;
    window.open(whatsappUrl, '_blank');
  };
  
 
  return (
    <main className="container mx-auto px-4 py-16">
     <div className="max-w-6xl mx-auto">
       <div className="grid md:grid-cols-2 gap-12">
         {/* Contact Information */}
         <div className="space-y-8">
           <h2 className="text-3xl font-bold text-gray-800 mb-6">Informasi Kontak</h2>
           
           {/* Location */}
            <div className="flex items-start space-x-4 cursor-pointer"
              onClick={handleAddressClick}>
             <div className="bg-purple-100 p-3 rounded-full flex-shrink-0">
               <MapPin className="w-6 h-6 text-purple-600" />
             </div>
             <div>
               <h3 className="font-semibold text-gray-800 mb-2">Alamat</h3>
               <p className="text-gray-600 leading-relaxed">
                 The City Resort Residence Rukan Malibu Blok. I No.18-19,
                 Tower GRHA 911,
                 Jl. Boulevard Raya, RT.7/RW.14,
                 Cengkareng Timur, Kecamatan Cengkareng,
                 Kota Jakarta Barat, DKI Jakarta 11730
               </p>
             </div>
           </div>

           {/* Phone */}
            <div className="flex items-start space-x-4 cursor-pointer"
              onClick={handlePhoneClick}
            >
             <div className="bg-purple-100 p-3 rounded-full flex-shrink-0">
               <Phone className="w-6 h-6 text-purple-600" />
             </div>
             <div>
               <h3 className="font-semibold text-gray-800 mb-2">Telepon</h3>
               <p className="text-gray-600 hover:text-purple-600 transition-colors">+62 852-8241-1391</p>
             </div>
           </div>

           {/* Email */}
           <div 
             className="flex items-start space-x-4 cursor-pointer"
             onClick={handleEmailClick}
           >
             <div className="bg-purple-100 p-3 rounded-full flex-shrink-0">
               <Mail className="w-6 h-6 text-purple-600" />
             </div>
             <div>
               <h3 className="font-semibold text-gray-800 mb-2">Email</h3>
               <p className="text-gray-600 hover:text-purple-600 transition-colors">
                 papakilobarbershop@gmail.com
               </p>
             </div>
           </div>

           {/* Hours */}
           <div className="flex items-start space-x-4">
             <div className="bg-purple-100 p-3 rounded-full flex-shrink-0">
               <Clock className="w-6 h-6 text-purple-600" />
             </div>
             <div>
               <h3 className="font-semibold text-gray-800 mb-2">Jam Operasional</h3>
               <p className="text-gray-600">Setiap Hari: 10:00 - 22:00</p>
             </div>
           </div>

            {/* Social Media */}
            <div 
             className="flex items-start space-x-4 cursor-pointer"
             onClick={handleInstagramClick}
           >
             <div className="bg-purple-100 p-3 rounded-full flex-shrink-0">
               <Instagram className="w-6 h-6 text-purple-600" />
             </div>
             <div>
               <h3 className="font-semibold text-gray-800 mb-2">Instagram</h3>
               <p className="text-gray-600 hover:text-purple-600 transition-colors">
                 @papakilo.hairstudio
               </p>
             </div>
           </div>
         </div>

         {/* Contact Form */}
         <div className="bg-white p-8 rounded-xl shadow-lg">
           <h2 className="text-3xl font-bold text-gray-800 mb-6">Kirim Pesan</h2>
           {/* Form Customer */}
           <FormMessage />
         </div>
       </div>
     </div>
   </main>
  )
}

export default SecondSection